import { gql, TypedDocumentNode } from '@apollo/client'

import { AbTestDTO } from 'features/ab-tests/api/types/AbTestDTO'
import { permitFields } from 'providers/graphql/utils'

import type { Data, Variables } from './types'

type Props = {
  withYp2395?: boolean
}

export const GET_AB_TEST = ({ withYp2395 }: Props): TypedDocumentNode<Data, Variables> => gql`
  query getAbTest($id: ID!) {
    node(id: $id) {
      ... on AbTest {
        ${permitFields<AbTestDTO>({
          cookieLifetime: withYp2395,
          trafficSplitType: withYp2395,
        })}

        domain {
          activeAbTest {
            id
          }
          id
          name
        }
        variants
        id
        name
        status
        usedVariantsData {
          name
          reportedKeyValue
        }
      }
    }
  }
`
